import parse from 'html-react-parser';

import parseAnchor from 'services/htmlParse/parseAnchor';

const extractTextContent = value => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (Array.isArray(value)) return value.map(extractTextContent).join('');
  if (value.props?.children) return extractTextContent(value.props.children);
  return '';
};

const extractAnchorsFromHTML = (html, anchorTag = 'h2') => {
  if (!html) return null;
  const parsedHtml = parse(html);
  const nodes = Array.isArray(parsedHtml) ? parsedHtml : [parsedHtml];
  return nodes
    .filter(({ type }) => type === anchorTag)
    .map(({ props }) => {
      const label = extractTextContent(props.children);
      return { label, key: parseAnchor(label) };
    });
};

export default extractAnchorsFromHTML;
